import * as actions from "../utils/action";

const intitialState = {
    orderList: [],
};

const orderReducer = (state, action) => {
    state = state || intitialState;

    switch (action.type) {
        case actions.SET_ORDER: {
            return Object.assign({}, state, {
                ...state,
                orderList: action.payload,
            });
        }

        case actions.SET_ORDER_Filters: {
            return Object.assign({}, state, {
                ...state,
                filters: action.payload,
            });
        }
        case actions.SET_PRODUCT: {
            return Object.assign({}, state, {
                ...state,
                productList: action.payload,
            });
        }
        case actions.SET_REFERRINGOFFICE: {
            return Object.assign({}, state, {
                ...state,
                referringOfficeList: action.payload,
            });
        }
        case actions.RESET_PRODUCT:
            return {
                ...state,
                productList: null,
            };
        case actions.RESET_REFERRINGOFFICE:
            return {
                ...state,
                referringOfficeList: null,
            };
        case actions.SET_STATE: {
            return Object.assign({}, state, {
                ...state,
                stateList: action.payload,
            });
        }
        case actions.RESET_STATE:
            return {
                ...state,
                stateList: null,
            };

        default:
            return state;
    }
};

export default orderReducer;
